import angular from 'angular';
import rwCaptcha from './rw-captcha-directive';

export default angular
  .module('rw-captcha', [])
  .directive('rwCaptcha', rwCaptcha);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-captcha/rw-captcha-module.js